export default function getPayload(token) {
  if (token && (token instanceof String || typeof token === 'string')) {
    try {
      const tokenSplit = token.split('.');
      const [, payload] = tokenSplit;
      const decodedPayload = atob(payload);
      return JSON.parse(decodedPayload);
    } catch (ex) {
      console.error(ex);
      return {};
    }
  }
  return {};
}
